import { Box } from "@mui/material";
import { TaskerMessage, TaskerConfig } from "@t3/shared";
import { RejectOptionDisplay } from "./RejectOptionDisplay";
import { ProgramCard } from "./ProgramCard";

interface RejectedReasonsSectionProps {
  message: TaskerMessage;
  userTaskerConfigs: TaskerConfig[];
}

export const RejectedReasonsSection = ({
  message,
  userTaskerConfigs,
}: RejectedReasonsSectionProps) => {
  if (message.reviewStatus !== "rejected" || !message.rejectOptions) {
    return null;
  }

  const eligibleConfigs = userTaskerConfigs.filter((config) =>
    message.eligibleProgramIds.includes(config.programId),
  );

  return (
    <Box sx={{ mt: 0 }}>
      {eligibleConfigs.map((config) => {
        const programRejectOptions = message.rejectOptions?.filter((option) =>
          config.rejectOptions.some((ro) => ro.id === option.id),
        );

        if (!programRejectOptions?.length) return null;

        return (
          <ProgramCard
            key={config.id}
            programName={config.programName}
            programColor={config.programColor}
          >
            {programRejectOptions.map((option) => (
              <RejectOptionDisplay key={option.id} option={option} />
            ))}
          </ProgramCard>
        );
      })}
    </Box>
  );
};
